export default "__VITE_ASSET__f35NgTNO__"